import header from './zh/header';
import buttons from './zh/buttons';
import home from './zh/home';
import search from './zh/search';
import companyPages from './zh/pages/company';
import contactPages from './zh/pages/contact';
import recruitPages from './zh/pages/recruit';
import applicationsPages from './zh/pages/applications';
import newsPages from './zh/pages/news'; 
import productsPages from './zh/pages/products';

export default {
  header,
  buttons,
  home,
  search,
  pages: {
    company: companyPages,
    news: newsPages, 
    contact: contactPages,
    recruit: recruitPages,
    applications: applicationsPages,
    products: productsPages
  }
};